import { FC, PropsWithChildren } from 'react';
import { Box, Stack } from '@mui/material';
import assets from '../../../assets';

const MainLayoutWrapper: FC<PropsWithChildren> = ({ children }) => {

  return (
    <Box
      component="main"
      sx={{
        width: "100%",
        height: "100%",
        minHeight: "100vh",
        backgroundColor: "#DEDEDE",
      }}>
      <Box sx={(theme) => ({
        backgroundImage: `url(${assets.images.background})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto',
        backgroundColor: "#DEDEDE",
        padding: "72px 25px 20px 25px",
        [theme.breakpoints.down('laptopL')]: {
          padding: "25px min(25px, 2%)",
          paddingTop: '84px'
        },
        [theme.breakpoints.down('tablet')]: {
          paddingBottom: '100px'
        }
      })}>
        <Stack direction="column" width="100%">
          {children}
        </Stack>
      </Box>
    </Box>
  )
};

export default MainLayoutWrapper;
